// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".customer[data-v-b4e21e86] {\n  background-color: #fff;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 48>"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB","file":"checkHeader.vue","sourcesContent":[".customer {\n  background-color: #fff;\n}"]}]);
// Exports
module.exports = exports;
